import React, { useState } from 'react';
import { AuthSession } from '../types';
import './Login.css';

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

interface LoginProps {
  onLogin: (session: AuthSession) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!username.trim() || !password.trim()) {
      setError('Informe seu login e senha.');
      return;
    }

    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: username.trim(),
          email: username.trim(),
          password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Login invalido.');
      }

      onLogin(data);
    } catch (loginError) {
      setError(loginError instanceof Error ? loginError.message : 'Nao foi possivel entrar.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login-page">
      <div className="login-shell">
        <div className="login-panel">
          <div>
            <span className="login-kicker">Acesso privado</span>
            <h1>Monitor de apartamentos</h1>
            <p>
              Entre para acompanhar os apartamentos anunciados no Gama e em Santa Maria
              com preço, quartos, metragem e condomínio quando a fonte informar.
            </p>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <label>
              Login
              <input
                type="text"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                placeholder="E-mail ou usuário"
                autoComplete="username"
              />
            </label>

            <label>
              Senha
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Sua senha"
                autoComplete="current-password"
              />
            </label>

            {error && <p className="login-error">{error}</p>}

            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? 'Entrando' : 'Entrar'}
              <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-arrow-right'}`}></i>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;
